import React from "react";
import reactCSS from "reactcss";
import { ChromePicker } from "react-color";

class ColorPicker extends React.Component {
	state = {
		displayColorPicker: false,
		color: this.props.defaultColor ? this.props.defaultColor : "#000000",
		isDefault: false,
		top: 0,
		bottom: "auto",
		right: "auto",
	};

	target = React.createRef();

	componentDidUpdate(prevProps, prevState) {
		if (!prevState.isDefault && prevProps.defaultColor) {
			// // console.log(prevState.color + " >> " + this.props.defaultColor);

			if (prevState.color !== this.props.defaultColor) {
				this.setState({
					color: this.props.defaultColor,
				});
			}
		}
	}

	refresh = () => {
		this.setState({
			color: "#000000",
		});
	};

	setColor = (color) => {
		this.setState({
			color,
		});
	};

	handleClick = (evt) => {
		const x = evt.clientX + 225;
		const y = evt.clientY + 240;

		let left = "auto",
			right = "auto",
			top = "auto",
			bottom = "auto";

		if (window.innerWidth < x) {
			left = "auto";
			right = 0;
		} else {
			left = evt.clientX;
			right = "auto";
		}

		if (window.innerHeight < y) {
			top = "auto";
			bottom = 0;
		} else {
			top = evt.clientY;
			bottom = "auto";
		}

		this.setState({ displayColorPicker: !this.state.displayColorPicker, top, left, right, bottom });
	};

	handleClose = (e) => {
		this.setState({ displayColorPicker: false });

		if (this.props.onChange) {
			this.props.onChange(this.state.color, this.target.current);
		}
	};

	handleChange = (color) => {
		this.setState({ color: color.hex, isDefault: true });
	};

	render() {
		const styles = reactCSS({
			default: {
				color: {
					width: "36px",
					height: "100%",
					borderRadius: "2px",
					background: this.state.color,
				},
				swatch: {
					padding: "5px",
					background: "#fff",
					borderRadius: "1px",
					boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
					display: "inline-block",
					cursor: "pointer",
					height: "36px",
				},
				popover: {
					position: "fixed",
					top: this.state.top,
					left: this.state.left,
					right: this.state.right,
					bottom: this.state.bottom,
					zIndex: "2",
					userSelect: "none",
				},
				cover: {
					position: "fixed",
					top: "0px",
					right: "0px",
					bottom: "0px",
					left: "0px",
				},
				title: {
					display: "inline-block",
					padding: "0px 10px",
				},
				wrap: {
					display: "inline-flex",
					alignItems: "center",
				},
			},
		});

		return (
			<div id={this.props.id} className={this.props.className} style={styles.wrap}>
				{this.props.label ? (
					<>
						<span style={styles.title}>색상</span>
					</>
				) : (
					<span style={{ padding: 0 }}>&nbsp;</span>
				)}
				<div className="swatch" style={styles.swatch} onClick={this.handleClick}>
					<div style={styles.color} />
				</div>
				{this.state.displayColorPicker ? (
					<div style={styles.popover}>
						<div style={styles.cover} onClick={this.handleClose} />
						<ChromePicker id={this.props.id} ref={this.target} color={this.state.color} onChange={this.handleChange} />
					</div>
				) : null}
			</div>
		);
	}
}

export default ColorPicker;
